import { request } from "~/utils/api";
import { openRequest, closeRequest } from "./app";
import { setVerificationCookie } from "~/utils/verification";

export const VERIFY_TURNSTILE = "VERIFY_TURNSTILE";

export const verifyTurnstile = ({ token }) => {
  return (dispatch) => {
    dispatch(openRequest(VERIFY_TURNSTILE));
    return request({
      url: "/turnstile/verify",
      method: "POST",
      data: { token },
    })
      .then((res) => {
        dispatch(closeRequest(VERIFY_TURNSTILE));

        // 验证成功（200 响应），设置 cookie（客户端）
        if (res.data.success && res.data.verified_token) {
          setVerificationCookie(res.data.verified_token, res.data.expires_at);
        }

        return res.data;
      })
      .catch((err) => {
        dispatch(closeRequest(VERIFY_TURNSTILE));
        // 验证失败（422）或其他错误，抛出错误供上层处理
        // 可以在这里添加更友好的错误信息
        if (err.statusCode === 422 || err.response?.status === 422) {
          throw new Error("人机验证失败，请重试");
        }
        throw err;
      });
  };
};

export const checkTurnstileToken = ({ token }) => {
  return request({
    url: "/turnstile/check",
    method: "POST",
    data: { token },
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};
